import { render, staticRenderFns } from "./VideoWikiChat.vue?vue&type=template&id=14be3b02&scoped=true&"
import script from "./VideoWikiChat.vue?vue&type=script&lang=js&"
export * from "./VideoWikiChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoWikiChat.vue?vue&type=style&index=0&id=14be3b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be3b02",
  null
  
)

export default component.exports